const GetThematicAreaAction = {
    Request: 'GetThematicAreaActionRequest',
    Success: 'GetThematicAreaActionSuccess',
    Failure: 'GetThematicAreaActionFailure',
};
const LoadThematicAreasAction = {
    Request: 'LoadThematicAreasActionRequest',
    Success: 'LoadThematicAreasActionSuccess',
    Failure: 'LoadThematicAreasActionFailure',
};
const RemoveThematicAreaAction = {
    Request: 'RemoveThematicAreaActionRequest',
    Success: 'RemoveThematicAreaActionSuccess',
    Failure: 'RemoveThematicAreaActionFailure',
};
const SaveThematicAreaAction = {
    Request: 'SaveThematicAreaActionRequest',
    Success: 'SaveThematicAreaActionSuccess',
    Failure: 'SaveThematicAreaActionFailure',
};
const UnloadThematicAreaAction = {
    Request: 'UnloadThematicAreaActionRequest',
    Success: 'UnloadThematicAreaActionSuccess',
}
const UpdateThematicAreaAction = {
    Request: 'UpdateThematicAreaActionRequest',
    Success: 'UpdateThematicAreaActionSuccess',
    Failure: 'UpdateThematicAreaActionFailure',
}
const GetPasswordConfigsAction = {
    Request: 'GetPasswordConfigsActionRequest',
    Success: 'GetPasswordConfigsActionSuccess',
    Failure: 'GetPasswordConfigsActionFailure',
}
const UpdatePasswordConfigAction = {
    Request: 'UpdatePasswordConfigActionRequest',
    Success: 'UpdatePasswordConfigActionSuccess',
    Failure: 'UpdatePasswordConfigActionFailure',
}
const FetchTemplatesAction = {
    Request: 'FetchTemplatesActionRequest',
    Success: 'FetchTemplatesActionSuccess',
    Failure: 'FetchTemplatesActionFailure',
}

const GetTemplateAction = {
    Request: 'GetTemplateActionRequest',
    Success: 'GetTemplateActionSuccess',
    Failure: 'GetTemplateActionFailure',
}

const UpdateTemplateAction = {
    Request: 'UpdateTemplateActionRequest',
    Success: 'UpdateTemplateActionSuccess',
    Failure: 'UpdateTemplateActionFailure',
}

const GetAttachmentConfigsAction = {
    Request: 'GetAttachmentConfigsActionRequest',
    Success: 'GetAttachmentConfigsActionSuccess',
    Failure: 'GetAttachmentConfigsActionFailure',
}
const UpdateAttachmentConfigAction = {
    Request: 'UpdateAttachmentConfigActionRequest',
    Success: 'UpdateAttachmentConfigActionSuccess',
    Failure: 'UpdateAttachmentConfigActionFailure',
}
const LoadAgreementHistoriesAction = {
    Request: 'LoadAgreementHistoriesActionRequest',
    Success: 'LoadAgreementHistoriesActionSuccess',
    Failure: 'LoadAgreementHistoriesActionFailure',
};
const GetAgreementAction = {
    Request: 'GetAgreementActionRequest',
    Success: 'GetAgreementActionSuccess',
    Failure: 'GetAgreementActionFailure',
};
const UnloadAgreementAction = {
    Request: 'UnloadAgreementActionRequest',
    Success: 'UnloadAgreementActionSuccess',
}
const UpdateAgreementAction = {
    Request: 'UpdateAgreementActionRequest',
    Success: 'UpdateAgreementActionSuccess',
    Failure: 'UpdateAgreementActionFailure',
}
const GetAuthorizationServiceSettingsAction = {
    Request: 'GetAuthorizationServiceSettingsActionRequest',
    Success: 'GetAuthorizationServiceSettingsActionSuccess',
    Failure: 'GetAuthorizationServiceSettingsActionFailure',
}
const UpdateAuthorizationServiceSettingsAction = {
    Request: 'UpdateAuthorizationServiceSettingsActionRequest',
    Success: 'UpdateAuthorizationServiceSettingsActionSuccess',
    Failure: 'UpdateAuthorizationServiceSettingsActionFailure',
}
const GetCommentConfigsAction = {
    Request: 'GetCommentConfigsActionRequest',
    Success: 'GetCommentConfigsActionSuccess',
    Failure: 'GetCommentConfigsActionFailure',
}
const UpdateCommentConfigAction = {
    Request: 'UpdateCommentConfigActionRequest',
    Success: 'UpdateCommentConfigActionSuccess',
    Failure: 'UpdateCommentConfigActionFailure',
}
function getThematicArea(id) {
    return {
        type: GetThematicAreaAction.Request,
        payload: id
    }
}

function loadThematicAreas() {
    return {
        type: LoadThematicAreasAction.Request
    }
}
function removeThematicArea(id) {
    return {
        type: RemoveThematicAreaAction.Request,
        payload: id
    }
}

function saveThematicArea(Agreement) {
    return {
        type: SaveThematicAreaAction.Request,
        payload: Agreement
    }
}

function unloadThematicArea() {
    return {
        type: UnloadThematicAreaAction.Request
    }
}

function updateThematicArea(Agreement) {
    return {
        type: UpdateThematicAreaAction.Request,
        payload: Agreement
    }
}

function getPasswordConfigs() {
    return {
        type: GetPasswordConfigsAction.Request
    }
}

function updatePasswordConfig(passwordConfig) {
    return {
        type: UpdatePasswordConfigAction.Request,
        payload: passwordConfig
    }
}
function getAttachmentConfigs() {
    return {
        type: GetAttachmentConfigsAction.Request
    }
}
function updateAttachmentConfig(attachmentConfig) {
    return {
        type: UpdateAttachmentConfigAction.Request,
        payload: attachmentConfig
    }
}
function loadAgreementHistories() {
    return {
        type: LoadAgreementHistoriesAction.Request
    }
}
function getAgreement(id) {
    return {
        type: GetAgreementAction.Request,
        payload: id
    }
}
function unloadAgreement() {
    return {
        type: UnloadAgreementAction.Request
    }
}

function updateAgreement(agreement) {
    return {
        type: UpdateAgreementAction.Request,
        payload: agreement
    }
}
function fetchTemplates() {
    return {
        type: FetchTemplatesAction.Request,
    }
}

function getTemplate(id) {
    return {
        type: GetTemplateAction.Request,
        payload: id
    }
}

function updateTemplate(template) {
    return {
        type: UpdateTemplateAction.Request,
        payload: template
    }
}

function getAuthorizationServiceSettings() {
    return {
        type: GetAuthorizationServiceSettingsAction.Request
    }
}

function updateAuthorizationServiceSettings(settings) {
    return {
        type: UpdateAuthorizationServiceSettingsAction.Request,
        payload: settings,
    }
}

function getCommentConfigs() {
    return {
        type: GetCommentConfigsAction.Request
    }
}

function updateCommentConfig(setting) {
    return {
        type: UpdateCommentConfigAction.Request,
        payload: setting,
    }
}

export const SettingActionCreators = {
    getThematicArea,
    loadThematicAreas,
    removeThematicArea,
    saveThematicArea,
    unloadThematicArea,
    updateThematicArea,
    getPasswordConfigs,
    updatePasswordConfig,
    getAttachmentConfigs,
    updateAttachmentConfig,
    fetchTemplates,
    getTemplate,
    updateTemplate,
    loadAgreementHistories,
    getAgreement,
    unloadAgreement,
    updateAgreement,
    getAuthorizationServiceSettings,
    updateAuthorizationServiceSettings,
    getCommentConfigs,
    updateCommentConfig
}

export const SettingActions = {
    GetThematicAreaAction,
    LoadThematicAreasAction,
    RemoveThematicAreaAction,
    SaveThematicAreaAction,
    UnloadThematicAreaAction,
    UpdateThematicAreaAction,
    GetPasswordConfigsAction,
    UpdatePasswordConfigAction,
    GetAttachmentConfigsAction,
    UpdateAttachmentConfigAction,
    LoadAgreementHistoriesAction,
    GetAgreementAction,
    UnloadAgreementAction,
    UpdateAgreementAction,
    FetchTemplatesAction,
    GetTemplateAction,
    UpdateTemplateAction,
    GetAuthorizationServiceSettingsAction,
    UpdateAuthorizationServiceSettingsAction,
    GetCommentConfigsAction,
    UpdateCommentConfigAction
}